export class InvalidMarketplaceException extends Error {
    constructor(public readonly platform: string) {
        super(`Unsupported marketplace platform: ${platform}`);
    }
}
